import edap from '@homeaway/edap-wrapper';

// EDAP EVENTS
export const EDIT_RESERVATION_MESSAGE_PRESENTED =
    'edit_reservation_message.presented';
export const TRIP_MESSAGE_SET_PRESENTED = 'trip_message_set.presented';
export const TRIP_SEND_MESSAGE_SELECTED = 'trip_send_message.selected';
export const TRIP_SEND_MESSAGE_SUCCEEDED = 'trip_send_message.succeeded';

// ACTION LOCATIONS
export const MODIFY_BOOKING = 'modify_booking';
export const TRIP_MESSAGES = 'trip_messages';

// ACTION TYPE
export const MODIFY_REQUEST = 'modify_request';

export const triggerEdap = (name, data) => {
    edap().push({
        name,
        data,
    });
};

export const editReservationMessagePresented = ({
    actionLocation,
    experienceType,
    reservationUUID,
}) => {
    triggerEdap(EDIT_RESERVATION_MESSAGE_PRESENTED, {
        action_location: actionLocation,
        experience_type: experienceType,
        reservation_id: reservationUUID,
    });
};

export const tripMessageSetPresented = ({actionLocation, reservationUUID}) => {
    const data = {
        action_location: actionLocation,
    };
    if (reservationUUID) {
        data.reservation_id = reservationUUID;
    }
    triggerEdap(TRIP_MESSAGE_SET_PRESENTED, data);
};

export const tripSendMessageSelected = ({actionLocation, reservationUUID}) => {
    const data = {
        action_location: actionLocation,
    };
    if (reservationUUID) {
        data.reservation_id = reservationUUID;
    }
    triggerEdap(TRIP_SEND_MESSAGE_SELECTED, data);
};

export const tripSendMessageSucceeded = ({actionLocation, reservationUUID}) => {
    const data = {
        action_location: actionLocation,
    };
    if (reservationUUID) {
        data.reservation_id = reservationUUID;
    }
    triggerEdap(TRIP_SEND_MESSAGE_SUCCEEDED, data);
};
